import { render, staticRenderFns } from "./CompetitiveProcessesWrapper.vue?vue&type=template&id=9ef4de86&scoped=true"
import script from "./CompetitiveProcessesWrapper.vue?vue&type=script&lang=js"
export * from "./CompetitiveProcessesWrapper.vue?vue&type=script&lang=js"
import style0 from "./CompetitiveProcessesWrapper.vue?vue&type=style&index=0&id=9ef4de86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef4de86",
  null
  
)

export default component.exports